import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalculator = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0,0h24v24h-24Z" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M14.8,18h3"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M14.8,15h3"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M3,12h18"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M21,18.652c0,1.297 -1.052,2.348 -2.348,2.348h-13.304c-1.297,0 -2.348,-1.051 -2.348,-2.348v-13.304c0,-1.297 1.051,-2.348 2.348,-2.348h13.304c1.296,0 2.348,1.051 2.348,2.348v13.304Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M15,7.5h3"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M6,7.5h3"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M7.5,9v-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M6.44,15.44l2.12,2.12"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M6.44,17.56l2.12,-2.12"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M12,3v18"
			})
		]
	})
});
export default SvgCalculator;
